import { notifications } from "@mantine/notifications";

export const creationNotification = (
  createdItemTitle: string,
  success: boolean
) => {
  if (success) {
    notifications.show({
      title: "Başarılı.",
      message: `${createdItemTitle} başarılı bir şekilde oluşturuldu.`,
      autoClose: 4000,
      withBorder: true,
      color: "green",
    });
  } else {
    notifications.show({
      title: "Bilinmeyen Hata.",
      message: "Oluşturma başarısız.",
      color: "red",
      autoClose: 4000,
      withBorder: true,
    });
  }
};

export const deleteNotification = (success: boolean, successMessage?: string) => {
  if (success) {
    notifications.show({
      title: "Başarılı.",
      message: successMessage ?? `Silme işlemi başarılı.`,
      autoClose: 4000,
      withBorder: true,
      color: "green",
    });
  } else {
    notifications.show({
      title: "Bilinmeyen Hata.",
      message: "Silme işlemi başarısız.",
      color: "red",
      autoClose: 4000,
      withBorder: true,
    });
  }
};

export const updateNotification = (success: boolean) => {
  if (success) {
    notifications.show({
      title: "Başarılı.",
      message: `Bilgiler başarılı bir şekilde güncellendi.`,
      autoClose: 4000,
      withBorder: true,
      color: "green",
    });
  } else {
    notifications.show({
      title: "Bilinmeyen Hata.",
      message: "Bilgi güncellenmesi sırasında bir hata meydana geldi.",
      color: "red",
      autoClose: 4000,
      withBorder: true,
    });
  }
};

export const saveNotification = (success: boolean) => {
  if (success) {
    notifications.show({
      title: "Kaydedildi.",
      message: `Kaydetme işlemi başarılı.`,
      autoClose: 4000,
      withBorder: true,
      color: "green",
    });
  } else {
    notifications.show({
      title: "Bilinmeyen Hata.",
      message: "Kaydetme sırasında bir hata meydana geldi.",
      color: "red",
      autoClose: 4000,
      withBorder: true,
    });
  }
};

interface ErrorNotificationParams {
  title?: string;
  message?: string;
  color?: string;
  autoClose?: number;
  withBorder?: boolean;
}

export const errorNotification = ({
  title = "Bilinmeyen Hata.",
  message = "İşlem sırasında beklenmedik bir hata oluştu.",
  color = "red",
  autoClose = 4000,
  withBorder = true,
}: ErrorNotificationParams = {}) => {
  notifications.show({
    title,
    message,
    color,
    autoClose,
    withBorder,
  });
};

export const loginErrorNotification = () => {
  notifications.show({
    title: "Giriş Yapılamadı.",
    message: "Giriş bilgilerini doğru girdiğinizden emin olun.",
    color: "red",
    autoClose: 4000,
    withBorder: true,
  });
};

export const terminalCreateError = ({
  title = "Oluşturma Başarısız",
  message = "Tablet oluşturabilmek için önce terminal logosu yükleyiniz. Lütfen ayarlardan terminal logonuzu ekleyin.",
  color = "red",
  autoClose = 4000,
  withBorder = true,
}: ErrorNotificationParams = {}) => {
  notifications.show({
    title,
    message,
    color,
    autoClose,
    withBorder,
  });
};

export const shiftAssignSuccessNotif = ({
  title = "Başarılı.",
  message = "Vardiya ataması başarılı.",
  color = "green",
  autoClose = 4000,
  withBorder = true,
}: ErrorNotificationParams = {}) => {
  notifications.show({
    title,
    message,
    color,
    autoClose,
    withBorder,
  });
};

export const sameShiftCodeErrorNotif = () => {
  notifications.show({
    title: "Hata.",
    message: "Bu vardiya kodu başka bir vardiya için kullanılıyor.",
    color: "red",
    autoClose: 4000,
    withBorder: true,
  });
};

export const thisShiftNotDeleteableNotif = () => {
  notifications.show({
    title: "Hata.",
    message:
      "Bu vardiyaya atanmış kişiler bulunduğundan silme işlemi gerçekleştirilemiyor.",
    color: "red",
    autoClose: 4000,
    withBorder: true,
  });
};

export const samePhoneNumberErroNotif = () => {
  notifications.show({
    title: "Hata.",
    message: "Bu telefon numarası kullanılmaktadır.",
    color: "red",
    autoClose: 4000,
    withBorder: true,
  });
};

export const pleaseSelectShiftInfoNotif = () => {
  notifications.show({
    message: "Lütfen bir vardiya seçiniz.",
    color: "#5C26FF",
    autoClose: 4000,
    withBorder: true,
  });
};

export const pleaseSelectStartTimeInfoNotif = () => {
  notifications.show({
    message: "Başlangıç tarihi seçiniz.",
    color: "#5C26FF",
    autoClose: 4000,
    withBorder: true,
  });
};

export const pleaseSelectEmployeeInfoNotif = () => {
  notifications.show({
    message: "En az bir çalışan seçiniz.",
    color: "#5C26FF",
    autoClose: 4000,
    withBorder: true,
  });
};

export const nothingChangedNotif = () => {
  notifications.show({
    message: "Herhangi bir değişiklik yapmadınız.",
    color: "#5C26FF",
    autoClose: 4000,
    withBorder: true,
  });
};

export const shiftConflictErrorNotif = () => {
  notifications.show({
    title: "Atama Başarısız.",
    message:
      "Bu kişiye atamak istediğiniz vardiya, mevcut bir vardiyasıyla çakışıyor.",
    color: "red",
    autoClose: 4000,
    withBorder: true,
  });
};

export const createNotification = ({ success, message }: any) => {
  notifications.show({
    message: message,
    color: success ? "green" : "red",
    autoClose: 4000,
    withBorder: true,
  });
};
